// import React, { useEffect, useMemo } from 'react'

// function RoleWiseFeatureWrapper(props) {

//     const Feature = useMemo(() => {
//         const filteredModulesAndFeatures = props?.user?.role?.permissions_role?.filter((item) => {
//             return item?.is_accessible == true && item?.feature_id;
//         });

//         const accessibleModulesAndFeatures = props?.features?.filter((item) => {
//             return filteredModulesAndFeatures?.some((item2) => {
//                 return item2?.feature_id == item?.id
//             })
//         })

//         const featureModulePairs = accessibleModulesAndFeatures?.map((item) => {
//             const feature = props?.features?.find((feature) => feature?.id == item?.id);
//             const module = props?.modules?.find((module) => module?.id == item?.module_id);
//             return {
//                 featureName: feature?.feature_name,
//                 moduleName: module?.frontend_module_name
//             };
//         }) || [];

//         const FilterModule = featureModulePairs?.filter((item) => item?.moduleName === props?.ModuleName)

//         return FilterModule?.find((item) => item?.featureName == props?.Featur_Name)?.featureName
//     }, [props?.uses, props?.features, props?.modules, props?.ModuleName, props?.Featur_Name]);



//     return (
//         <div>
//             {Feature ? props.children : ""}
//         </div>
//     )
// }

// export default RoleWiseFeatureWrapper

import React, { useMemo } from 'react';

function checkFeatureAccess(props) {
    const filteredModulesAndFeatures = props?.user?.role?.permissions_role?.filter((item) => {
        return item?.is_accessible == true && item?.feature_id;
    });

    const accessibleModulesAndFeatures = props?.features?.filter((item) => {
        return filteredModulesAndFeatures?.some((item2) => {
            return item2?.feature_id == item?.id
        })
    })

    const featureModulePairs = accessibleModulesAndFeatures?.map((item) => {
        const feature = props?.features?.find((feature) => feature?.id == item?.id);
        const module = props?.modules?.find((module) => module?.id == item?.module_id);
        return {
            featureName: feature?.feature_name,
            moduleName: module?.frontend_module_name
        };
    }) || [];

    const FilterModule = featureModulePairs?.filter((item) => item?.moduleName === props?.ModuleName)

    return FilterModule?.find((item) => item?.featureName == props?.Featur_Name)?.featureName
}

function RoleWiseFeatureWrapper(props) {
    const hasAccess = useMemo(() => {
        return checkFeatureAccess(
            props
        );
    }, [props?.user, props?.features, props?.modules, props?.ModuleName, props?.Featur_Name]);

    return <>{hasAccess ? props.children : null}</>;
}

export default RoleWiseFeatureWrapper;
export { checkFeatureAccess }; // 👈 export this for external usage
